import { useAppStore } from '@store'

/** Evita recentrado 3D durante sustituciones/dibujos que no deben mover la cámara. */
export async function withCameraFitBlocked<T>(operation: () => Promise<T>): Promise<T> {
  const { beginCameraViewPreservation, endCameraViewPreservation, clearCameraFitToItems } =
    useAppStore.getState()

  beginCameraViewPreservation()
  clearCameraFitToItems()
  const intervalId = setInterval(() => {
    clearCameraFitToItems()
  }, 30)

  try {
    return await operation()
  } finally {
    clearInterval(intervalId)
    endCameraViewPreservation()
    clearCameraFitToItems()
    // Mantener el bloqueo de fit un poco más que los timers de reaplicación de vista.
    setTimeout(() => clearCameraFitToItems(), 120)
    setTimeout(() => clearCameraFitToItems(), 320)
    setTimeout(() => clearCameraFitToItems(), 700)
  }
}
